import { Button, Paper } from '@mui/material'
import { COLUMNS_NAME } from 'Components/Constants/ColumnsNames'
import { currency } from 'Components/MUI_components/currencyFormatterTag'
import Reports from 'Components/Print/a4-report-print'
import React, { useState } from 'react'
import { DownloadTableExcel } from 'react-export-table-to-excel'
import ReactToPrint from 'react-to-print'
import { pageStyle } from "Components/Print/printPagesStyles";
import { getTransactionLabelBySourceCode, handleLedgerType } from 'Components/Constants/ReusableFunctions'
import LedgerTypesService from 'Service/Accounts/LedgerTypes.service'

const PreviewTable = (props) => {
const  {
    tableRef,
    componentRef,
    value,
    ledgers
} = props

    const DebitTotal = value.map((row) => row.entryType == 0 ? parseFloat(row.amount) : 0)
    .reduce((sum, i) => sum + i, 0);

    const creditTotal = value.map((row) => row.entryType == 1 ? parseFloat(row.amount) : 0)
    .reduce((sum, i) => sum + i, 0);

    const handleDisplayLedger = (ledgerCode) => {
        const foundLedger = ledgers.find((row) => row.code === ledgerCode);
        return foundLedger ? foundLedger.name : null;
    };
 

    return (
        <div >
            {value.length > 0 && (
                <Paper style={{ padding: "10px" }}>
                    <div className="flex-end">
                        <ReactToPrint
                            trigger={() => (
                                <Button
                                    style={{ margin: 5 }}

                                    variant="contained"
                                >
                                    Print
                                </Button>
                            )}
                            content={() => componentRef.current}
                            pageStyle={pageStyle.a4}
                        />
                        <DownloadTableExcel
                            filename="Day End"
                            currentTableRef={tableRef.current}
                        >
                            <Button
                                style={{ margin: 5 }}

                                variant="contained"
                            >
                                Export to Excel </Button>
                        </DownloadTableExcel>

                    </div>
                    <div className="justify-content-center"
                        ref={componentRef}>
                        <Reports
                            title={
                                "Preview Transactions"
                            }

                        >
                            <table
                                className="print-table mt "
                                aria-label="customized table"
                                ref={tableRef}>
                                <thead className="thead" style={{ borderBottom: "1px solid #24242450" }}>
                                    <tr style={{ backgroundColor: "#cacaca" }}>
                                        <th align="left">{COLUMNS_NAME.TRANSACTION_TYPE}</th>
                                        <th align="left">{COLUMNS_NAME.LEDGER_TYPE}</th>
                                        {/* <th align="left" >{COLUMNS_NAME.ENTRY_TYPE}</th> */}
                                        <th align="left">{COLUMNS_NAME.TRANSACTION_MODE}</th>
                                        <th align="right">{COLUMNS_NAME.DEBIT}</th>
                                        <th align="right">{COLUMNS_NAME.CREDIT}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <>
                                        {value.map((row, index) => (
                                            <>
                                            {row.amount ==  "0.00" || 0 ? ("") : (
                                                <tr key={index}>
                                                <td align="left">{getTransactionLabelBySourceCode(row.sourceCode, row.transactionTypeName)}</td>
                                                <td align="left">{handleDisplayLedger(row.ledgerType)}</td>
                                                <td align="left">{row.transactionType == 0 ? " CASH" : "CHEQUE"}</td>
                                                {row.amount < 0 ? (
                                                    <>
                                                        <td align="right"> {row.entryType == 0 ? `(${currency(row.amount)})`  : "-"}</td>
                                                        <td align="right">{row.entryType == 0 ? "-" : `(${currency(row.amount)})`  }</td>
                                                    </>
                                                   
                                                ):(
                                                    <>
                                                        <td align="right">{row.entryType == 0 ? currency(row.amount)  : "-"}</td>
                                                        <td align="right">{row.entryType == 0 ? "-" : currency(row.amount) }</td>
                                                    </>
                                              
                                                )}
                                                
                                            </tr>
                                            )}
                                                
                                            </>
                                        ))}
                                        {/* <tr>
                                            <td colSpan={3}></td>
                                            <td align="right"><strong>{DebitTotal<0 ? `(${ currency(DebitTotal)})` : currency(DebitTotal)}</strong> </td>
                                            <td align="right"><strong>{creditTotal<0 ? `(${ currency(creditTotal)})` : currency(creditTotal) }</strong> </td>
                                        </tr> */}

                                    </>
                                </tbody>
                            </table>

                        </Reports>

                    </div>
                </Paper>
            )}

        </div>
    )
}

export default PreviewTable